import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* Auto-generated. Do not edit! */
/* eslint-disable */

const SvgEu = props => /*#__PURE__*/_jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "rgb(0 0 0 / 60%)",
  ...props,
  children: [/*#__PURE__*/_jsxs("g", {
    clipPath: "url(#a)",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#039",
      d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#FC0",
      d: "m11.998 2.66.3.921h.973l-.784.57.295.922-.784-.57-.784.57.3-.922-.784-.57h.969l.299-.92Zm-4 1.067.3.921h.972l-.783.57.295.921-.784-.57-.784.57.3-.921-.784-.57h.969l.299-.92ZM5.065 6.661l.299.92h.973l-.784.57.295.922-.783-.57-.784.57.3-.922-.784-.57h.968zm-1.067 4 .3.92h.972l-.783.57.295.922-.784-.57-.784.57.3-.922-.784-.57h.969zm1.067 4 .299.92h.973l-.784.57.295.922-.783-.57-.784.57.3-.922-.784-.57h.968zm2.933 2.933.3.92h.972l-.783.57.295.922-.784-.57-.784.57.3-.921-.784-.57h.969zm8-13.867.3.921h.973l-.784.57.295.921-.784-.57-.784.57.3-.921-.784-.57h.969l.299-.92Zm2.933 2.934.3.92h.973l-.784.57.295.922-.784-.57-.783.57.3-.922-.785-.57h.97zm1.067 4 .3.92h.973l-.784.57.295.922-.784-.57-.784.57.3-.922-.784-.57h.969zm-1.067 4 .3.92h.973l-.784.57.295.922-.784-.57-.783.57.3-.922-.785-.57h.97zm-6.933 4 .3.92h.973l-.784.57.295.922-.784-.57-.784.57.3-.922-.784-.57h.969zm4-1.067.3.92h.973l-.784.57.295.922-.784-.57-.784.57.3-.921-.784-.57h.969z"
    })]
  }), /*#__PURE__*/_jsx("defs", {
    children: /*#__PURE__*/_jsx("clipPath", {
      id: "a",
      children: /*#__PURE__*/_jsx("path", {
        fill: "#fff",
        d: "M0 0h24v24H0z"
      })
    })
  })]
});
export default SvgEu;